import Metadata from "../metadata.js";
var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function getIddPrefix(country, callingCode, metadata) {
  var countryMetadata = new Metadata(metadata);
  if (countryMetadata.selectNumberingPlan(country, callingCode), countryMetadata.defaultIDDPrefix())
    return countryMetadata.defaultIDDPrefix();
  if (SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix()))
    return countryMetadata.IDDPrefix();
}
export {
  getIddPrefix as default
};
//# sourceMappingURL=getIddPrefix.js.map
